module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _c('section', [_c('m-loading', {
    attrs: {
      "text": "努力查询中..."
    }
  })], 1) : _c('section', [(_vm.payStatus === 0) ? _c('section', [_c('img', {
    staticClass: "status-icon",
    attrs: {
      "src": require("assets/images/error.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "status-tips"
  }, [_vm._v("\n        木有找到支付结果... "), _c('br'), _vm._v("\n        请稍后再查询 "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.payStatus === 1) ? _c('section', [_c('img', {
    staticClass: "status-icon",
    attrs: {
      "src": require("assets/images/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.expired) ? _c('p', {
    staticClass: "status-tips"
  }, [_vm._v("\n        您的帐户有效期延长至 "), _c('br'), _vm._v("\n        " + _vm._s(_vm.expired) + " "), _c('br'), _vm._v("\n        请登录美甲帮店务通“个人设置>我的帐户”中查看 "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "status-tips"
  }, [_vm._v("\n        购买成功~请用这个手机号码注册美甲帮店务通！"), _c('br'), _vm._v("\n        系统将自动为您激活账户，账户有效期从激活当日开始计算。"), _c('br'), _vm._v("\n        点击\n        "), _c('a', {
    attrs: {
      "href": "//mjb8.cn/00UH"
    }
  }, [_vm._v("\n          http://mjb8.cn/00UH\n        ")]), _vm._v("\n        下载美甲帮店务通！\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.payStatus === 2) ? _c('section', [_c('img', {
    staticClass: "status-icon",
    attrs: {
      "src": require("assets/images/error.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "status-tips"
  }, [_vm._v("\n        出错啦～您的支付没有成功！请稍候再试！"), _c('br'), _vm._v("\n        如有疑问，请拨打客服电话 "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "tel",
    attrs: {
      "href": "400-182-5818"
    }
  }, [_vm._v("\n          400-182-5818\n        ")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-69383fee!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Result.vue
// module id = 95
// module chunks = 2